export default {"src":"/_next/static/media/dev.b4aef5d6.svg","height":35,"width":43,"blurWidth":0,"blurHeight":0};